import { api } from '@/features/auth';

import {
  GetServicesResponse,
  GetServicesCategoriesResponse,
  GetServicesTagsResponse,
  GetServiceResponse,
  GetServiceRequest,
  CreateAdvisorIntroRequest,
} from './types';

export const serviceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getServicesCategories: builder.query<GetServicesCategoriesResponse['data'], void>({
      query: () => ({
        url: `items/service_categories`,
        method: 'GET',
        params: {
          fields: '*, labels.*',
          filter: `{"status": {"_eq": "published"}}`,
          sort: 'order',
        },
      }),
      transformResponse: ({ data }: GetServicesCategoriesResponse) => data,
    }),
    getServicesTags: builder.query<GetServicesTagsResponse['data'], void>({
      query: () => ({
        url: `items/service_tags`,
        method: 'GET',
        params: {
          fields: '*, labels.*',
          filter: `{"status": {"_eq": "published"}}`,
        },
      }),
      transformResponse: ({ data }: GetServicesTagsResponse) => data,
    }),
    getServices: builder.query<GetServicesResponse['data'], void>({
      query: () => ({
        url: `items/service_companies`,
        method: 'GET',
        params: {
          fields: [
            'id',
            'status',
            'name',
            'description',
            'address',
            'primary_phone_number',
            'secondary_phone_number',
            'website',
            'linkedin',
            'category.code',
            'category.labels.*',
            'category.order',

            // Tags:
            'tags.id',
            'tags.company',
            'tags.tag',

            // Logo:
            'logo.*',

            // TODO: get specific data:
            'contacts.*',
            'items.*',
            'documents.*',
            'credentials.*',
          ],
          filter: `{"status": {"_eq": "published"}}`,
          sort: '-created_at',
        },
      }),
      transformResponse: ({ data }: GetServicesResponse) => data,
    }),
    getService: builder.query<GetServiceResponse['data'], GetServiceRequest>({
      query: ({ id }) => ({
        url: `items/service_companies/${id}`,
        method: 'GET',
        params: {
          fields: [
            'id',
            'status',
            'name',
            'description',
            'address',
            'primary_phone_number',
            'secondary_phone_number',
            'website',
            'linkedin',
            'category.code',
            'category.labels.*',
            'category.order',

            // Tags:
            'tags.id',
            'tags.company',
            'tags.tag',

            // Logo:
            'logo.*',

            // TODO: get specific data:
            'contacts.*',
            'items.*',
            'documents.*',
            'credentials.*',
          ],
          filter: `{"status": {"_eq": "published"}}`,
        },
      }),
      transformResponse: ({ data }: GetServiceResponse) => data,
    }),
    createAdvisorIntroRequest: builder.mutation<void, CreateAdvisorIntroRequest>({
      query: (data: CreateAdvisorIntroRequest) => ({
        url: `items/intro_advisors`,
        method: 'POST',
        body: data,
      })
    }),
  }),
});

export const {
  useGetServicesQuery,
  useGetServicesCategoriesQuery,
  useGetServicesTagsQuery,
  useGetServiceQuery,
  useCreateAdvisorIntroRequestMutation,
} = serviceApi;
